module.exports = __webpack_public_path__ + "img/5_Train-01.f56e309a.png";